import React, { useState, useRef, useEffect, useCallback } from "react";
import { Navbar, PulsingDot, RadioDot, StarRow, FAQItem, BeforeAfterSlider, ZipResult, GLOBAL_STYLES } from "../components.jsx";
import {
  BLUE, NAVY, LIGHT, TEXT, MUTED, GREEN, isWinter,
  SERVICES, VEHICLE_TYPES, CONDITIONS, REVIEWS, FAQS, PRICING,
  DAYS_OF_WEEK, TIME_PREFS, COMBO_SAVINGS,
  GMAPS_URL, AMAPS_URL, QUICK_Q_PHONE, FORMSPREE_ID,
  lookupPrice, haversine, fetchZipData, getVehicleTier
} from "../data";

// ── Pricing accordion ─────────────────────────────────────────────────────────
function PricingAccordion() {
  const [open, setOpen] = useState(null);
  const tiers = [
    { key:"combo",    label:"Full Interior + Exterior", sub:"Best Value", featured:true },
    { key:"interior", label:"Interior Only",            sub:null,         featured:false },
    { key:"exterior", label:"Exterior Only",            sub:null,         featured:false },
  ];
  const rows = [
    { vehicle:"Sedan / Coupe",        tier:"sedan",      save: COMBO_SAVINGS.sedan },
    { vehicle:"SUV / Midsize Truck", tier:"suv",        save: COMBO_SAVINGS.suv },
    { vehicle:"Full-Size SUV / Truck",tier:"largetruck", save: COMBO_SAVINGS.largetruck },
  ];
  return (
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {tiers.map(t=>(
        <div key={t.key} style={{border:"1.5px solid #E5E7EB",borderRadius:10,overflow:"hidden",background:"#fff"}}>
          <button onClick={()=>setOpen(o=>o===t.key?null:t.key)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"15px 20px",background:"none",border:"none",cursor:"pointer",fontFamily:"'Outfit',sans-serif",gap:12}}>
            <div style={{textAlign:"left"}}>
              <span style={{fontSize:15,fontWeight:700,color:NAVY}}>{t.label}</span>
              {t.sub&&<span style={{marginLeft:10,background:"#16A34A",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:4}}>{t.sub}</span>}
            </div>
            <span style={{width:26,height:26,borderRadius:"50%",background:open===t.key?BLUE:LIGHT,color:open===t.key?"#fff":BLUE,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0,transition:"all 0.2s",fontWeight:700}}>{open===t.key?"−":"+"}</span>
          </button>
          <div style={{maxHeight:open===t.key?420:0,overflow:"hidden",transition:"max-height 0.32s ease"}}>
            <div style={{padding:"0 0 14px"}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr auto"+(t.key==="combo"?" auto":""),gap:t.key==="combo"?"0 32px":"0",padding:"8px 20px",background:"#F9FAFB",borderTop:"1px solid #F3F4F6"}}>
                <span style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:"0.06em"}}>Vehicle</span>
                <span style={{fontSize:11,fontWeight:700,color:BLUE,textTransform:"uppercase",letterSpacing:"0.06em",textAlign:"right"}}>Price</span>
                {t.key==="combo"&&<span style={{fontSize:11,fontWeight:700,color:"#16A34A",textTransform:"uppercase",letterSpacing:"0.06em",textAlign:"right"}}>You Save</span>}
              </div>
              {rows.map(({vehicle,tier,save})=>{
                const price=PRICING[t.key][tier];
                return(
                  <div key={tier} style={{display:"grid",gridTemplateColumns:"1fr auto"+(t.key==="combo"?" auto":""),gap:t.key==="combo"?"0 32px":"0",padding:"11px 20px",borderTop:"1px solid #F9FAFB",alignItems:"center"}}>
                    <span style={{fontSize:13,fontWeight:600,color:NAVY}}>{vehicle}</span>
                    <span style={{fontSize:14,fontWeight:700,color:BLUE,textAlign:"right"}}>${price}</span>
                    {t.key==="combo"&&<span style={{fontSize:13,fontWeight:700,color:"#16A34A",background:"#F0FDF4",border:"1px solid #86EFAC",padding:"2px 10px",borderRadius:20,textAlign:"right",whiteSpace:"nowrap"}}>Save $20</span>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
      <p style={{fontSize:12,color:"#9CA3AF",textAlign:"center",marginTop:2}}>All prices are estimates. Final pricing confirmed before the appointment starts.</p>
    </div>
  );
}

// ── Services accordion ────────────────────────────────────────────────────────
function ServicesAccordion({onBook}) {
  const [open, setOpen] = useState("combo");
  return (
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {SERVICES.map(s=>(
        <div key={s.id} style={{border:`1.5px solid ${open===s.id&&s.featured?"#16A34A":"#E5E7EB"}`,borderRadius:10,overflow:"hidden",background:"#fff"}}>
          <button onClick={()=>setOpen(o=>o===s.id?null:s.id)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"15px 20px",background:open===s.id&&s.featured?"#F0F5FF":"none",border:"none",cursor:"pointer",fontFamily:"'Outfit',sans-serif",gap:12,transition:"background 0.2s"}}>
            <div style={{textAlign:"left",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
              <span style={{fontSize:15,fontWeight:700,color:NAVY}}>{s.title}</span>
              {s.badge&&<span style={{background:"#16A34A",color:"#fff",fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:4}}>{s.badge}</span>}
              {s.id==="combo"&&<span style={{fontSize:11,color:"#16A34A",fontWeight:600}}>Most people choose this</span>}
              <span style={{fontSize:12,color:MUTED,fontWeight:500}}>{s.priceFrom} · {s.time}</span>
            </div>
            <span style={{width:26,height:26,borderRadius:"50%",background:open===s.id?BLUE:LIGHT,color:open===s.id?"#fff":BLUE,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0,transition:"all 0.2s",fontWeight:700}}>{open===s.id?"−":"+"}</span>
          </button>
          <div style={{maxHeight:open===s.id?700:0,overflow:"hidden",transition:"max-height 0.38s ease"}}>
            <div style={{padding:"0 20px 20px",borderTop:"1px solid #F3F4F6"}}>
              <p style={{fontSize:14,color:MUTED,lineHeight:1.75,margin:"14px 0 10px"}}>{s.desc}</p>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16}}>
                {s.photos.map((p,i)=>(
                  <img key={i} src={p} alt={`${s.title} ${i+1}`} style={{width:"100%",aspectRatio:"4/3",objectFit:"cover",borderRadius:8,display:"block"}}/>
                ))}
              </div>
              <button style={{fontSize:14,padding:"11px 26px",background:s.id==="combo"?"#16A34A":undefined,border:"none",borderRadius:6,color:"#fff",fontWeight:700,cursor:"pointer",fontFamily:"'Outfit',sans-serif",transition:"all 0.18s"}} className={s.id!=="combo"?"btn-p":""} onClick={()=>onBook(s.title)}>Book Now</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

// ── Reviews carousel ──────────────────────────────────────────────────────────
function ReviewsCarousel() {
  const [idx,setIdx]=useState(0);
  const [paused,setPaused]=useState(false);
  const timer=useRef(null);
  const next=useCallback(()=>setIdx(i=>(i+1)%REVIEWS.length),[]);
  const prev=()=>setIdx(i=>(i-1+REVIEWS.length)%REVIEWS.length);
  useEffect(()=>{
    if(paused){clearInterval(timer.current);return;}
    timer.current=setInterval(next,4500);
    return()=>clearInterval(timer.current);
  },[paused,next]);
  return(
    <div onMouseEnter={()=>setPaused(true)} onMouseLeave={()=>setPaused(false)} style={{position:"relative",maxWidth:560,margin:"0 auto"}}>
      <div style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:14,padding:"34px 38px",minHeight:170,textAlign:"center",boxShadow:"0 4px 24px rgba(0,0,0,0.05)"}}>
        <StarRow/>
        <p style={{fontSize:15,color:TEXT,lineHeight:1.8,margin:"16px 0 18px",fontStyle:"italic"}}>&ldquo;{REVIEWS[idx].review}&rdquo;</p>
        <p style={{fontSize:14,fontWeight:700,color:NAVY}}>{REVIEWS[idx].name}</p>
        <p style={{fontSize:12,color:MUTED,marginTop:3}}>Kodiak Detailing Customer</p>
      </div>
      <button onClick={prev} style={{position:"absolute",top:"50%",left:-18,transform:"translateY(-50%)",width:34,height:34,borderRadius:"50%",background:"#fff",border:"1.5px solid #E5E7EB",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,color:NAVY,boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>‹</button>
      <button onClick={next} style={{position:"absolute",top:"50%",right:-18,transform:"translateY(-50%)",width:34,height:34,borderRadius:"50%",background:"#fff",border:"1.5px solid #E5E7EB",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,color:NAVY,boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>›</button>
      <div style={{display:"flex",justifyContent:"center",gap:7,marginTop:18}}>
        {REVIEWS.map((_,i)=>(
          <button key={i} onClick={()=>setIdx(i)} style={{width:i===idx?20:7,height:7,borderRadius:4,background:i===idx?BLUE:"#D1D5DB",border:"none",cursor:"pointer",transition:"all 0.25s",padding:0}}/>
        ))}
      </div>
    </div>
  );
}

// ── Step bar ──────────────────────────────────────────────────────────────────
function StepBar({step}) {
  const labels=["Your Info","Vehicle","Service","Appointment"];
  return(
    <div style={{marginBottom:22}}>
      <div style={{display:"flex",gap:5,marginBottom:6}}>
        {labels.map((_,i)=><div key={i} style={{flex:1,height:4,borderRadius:4,background:i<step?BLUE:"#E5E7EB",transition:"background 0.3s"}}/>)}
      </div>
      <p style={{fontSize:12,color:MUTED}}>Step {step} of 4: <strong style={{color:NAVY}}>{labels[step-1]}</strong></p>
    </div>
  );
}

// ── Day + time preference picker ──────────────────────────────────────────────
function DayTimePicker({selectedDays, toggleDay, timePref, setTimePref}) {
  return(
    <div className="fcard">
      <h3>What Days and Time of Day Work Best?</h3>
      <p style={{fontSize:13,color:MUTED,marginBottom:16,lineHeight:1.55}}>
        Select all that apply. This helps coordinate scheduling, your actual appointment time is confirmed when we reply back.
      </p>

      <p style={{fontSize:12,fontWeight:600,color:NAVY,marginBottom:9}}>Preferred days</p>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:18}}>
        {DAYS_OF_WEEK.map(d=>(
          <button key={d} className={`day-chip${selectedDays.includes(d)?" on":""}`} onClick={()=>toggleDay(d)}>{d}</button>
        ))}
      </div>
      {selectedDays.length>0&&<p style={{fontSize:12,color:BLUE,marginBottom:14,fontWeight:600}}>Selected: {selectedDays.join(", ")}</p>}

      <p style={{fontSize:12,fontWeight:600,color:NAVY,marginBottom:9}}>Preferred time of day</p>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {TIME_PREFS.map(t=>(
          <div key={t} className={`rrow${timePref===t?" on":""}`} onClick={()=>setTimePref(t)} style={{alignItems:"center",flex:1}}>
            <RadioDot checked={timePref===t}/>
            <span style={{fontSize:13,fontWeight:600,color:timePref===t?NAVY:MUTED}}>{t==="Morning"?"🌅 Morning":t==="Afternoon"?"☀️ Afternoon":"🌙 Evening"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
export default function Home() {
  const [scrolled,    setScrolled]    = useState(false);
  const [bookInView,  setBookInView]  = useState(false);
  const [formStep,    setFormStep]    = useState(1);
  const [selectedDays,setSelectedDays]= useState([]);
  const [timePref,    setTimePref]    = useState("");
  const [toast,       setToast]       = useState("");
  const [form, setForm] = useState({
    name:"",email:"",phone:"",vehicleType:"",makeModel:"",color:"",condition:"",
    serviceType:"",appointmentType:"",contactPreference:"",zip:"",address:"",notes:"",
  });
  const [zipInfo,    setZipInfo]    = useState(null);
  const [zipLoading, setZipLoading] = useState(false);
  const [submitted,  setSubmitted]  = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [summary,    setSummary]    = useState(null);
  const [errors,     setErrors]     = useState({});
  const [copyMsg,    setCopyMsg]    = useState("");

  const bookRef    = useRef(null);
  const confirmRef = useRef(null);

  useEffect(()=>{
    const fn=()=>setScrolled(window.scrollY>40);
    window.addEventListener("scroll",fn);return()=>window.removeEventListener("scroll",fn);
  },[]);
  useEffect(()=>{
    const obs=new IntersectionObserver(([e])=>setBookInView(e.isIntersecting),{threshold:0.05});
    if(bookRef.current)obs.observe(bookRef.current);return()=>obs.disconnect();
  },[]);

  const set=(k,v)=>{
    setForm(f=>({...f,[k]:v}));
    if(k==="contactPreference"&&formStep===1)setFormStep(2);
    if(k==="vehicleType"&&formStep===2)setFormStep(3);
    if(k==="serviceType"&&formStep===3)setFormStep(4);
  };
  const toggleDay=d=>setSelectedDays(p=>p.includes(d)?p.filter(x=>x!==d):[...p,d]);

  const handleZipChange=async(raw)=>{
    const val=raw.replace(/\D/g,"").slice(0,5);
    set("zip",val);setZipInfo(null);
    if(val.length===5){
      setZipLoading(true);
      const r=await fetchZipData(val);
      if(r){const miles=Math.round(haversine(39.8334,-84.4138,r.lat,r.lon));setZipInfo({miles,city:r.city,state:r.state});}
      setZipLoading(false);
    }
  };
  const copyAddress=()=>{
    navigator.clipboard?.writeText("Brookville, Ohio 45309").then(()=>{setCopyMsg("Copied!");setTimeout(()=>setCopyMsg(""),2000);});
  };

  const bookService=(serviceTitle)=>{
    set("serviceType",serviceTitle);
    setFormStep(1);
    setToast(`✓ ${serviceTitle} selected!`);
    setTimeout(()=>setToast(""),3000);
    setTimeout(()=>bookRef.current?.scrollIntoView({behavior:"smooth",block:"start"}),80);
  };

  const currentPrice = (() => {
    const tier = getVehicleTier(form.vehicleType);
    const key = form.serviceType.includes("Full Interior") ? "combo"
              : form.serviceType.includes("Interior") ? "interior"
              : form.serviceType ? "exterior" : null;
    if (!tier || !key) return null;
    return PRICING[key]?.[tier] ?? null;
  })();

  const comboSavings = (() => {
    const tier = getVehicleTier(form.vehicleType);
    if (!tier || !form.serviceType.includes("Full Interior")) return null;
    return COMBO_SAVINGS[tier];
  })();

  const selectedCondition=CONDITIONS.find(c=>c.label===form.condition);
  const scrollTo=id=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});

  const validate=()=>{
    const e={};
    if(!form.name.trim())e.name="Required";
    if(!form.phone.trim())e.phone="Phone number is required";
    if(form.contactPreference==="email"){if(!form.email.match(/^[^@]+@[^@]+\.[^@]+$/))e.email="Email required since it is your preferred contact";}
    else if(form.email&&!form.email.match(/^[^@]+@[^@]+\.[^@]+$/))e.email="Please enter a valid email";
    if(!form.vehicleType)e.vehicleType="Please select your vehicle type";
    if(!form.condition)e.condition="Please select a condition";
    if(!form.serviceType)e.serviceType="Please select a service";
    if(!form.appointmentType)e.appointmentType="Please choose mobile or drop-off";
    if(!form.contactPreference)e.contactPreference="Please select how to reply back";
    if(form.appointmentType==="mobile"&&!/^\d{5}$/.test(form.zip))e.zip="Enter a valid 5-digit zip code";
    setErrors(e);return Object.keys(e).length===0;
  };

  const handleSubmit=async()=>{
    if(!validate())return;
    setSubmitting(true);
    const svcData=SERVICES.find(s=>s.title===form.serviceType);
    try{
      await fetch(`https://formspree.io/f/${FORMSPREE_ID}`,{
        method:"POST",
        headers:{"Content-Type":"application/json",Accept:"application/json"},
        body:JSON.stringify({
          _subject:`New Booking - ${form.name} - ${form.serviceType} - ${form.vehicleType}`,
          name:form.name,phone:form.phone,email:form.email||"Not provided",
          vehicle_type:form.vehicleType,make_model:form.makeModel||"Not provided",
          color:form.color||"Not provided",condition:form.condition,
          service:form.serviceType,appointment_type:form.appointmentType,
          estimated_price:currentPrice?`$${currentPrice}`:"To be confirmed",
          preferred_contact:form.contactPreference,
          preferred_days:selectedDays.length>0?selectedDays.join(", "):"Not specified",
          preferred_time:timePref||"Not specified",
          zip:form.zip||"N/A",address:form.address||"N/A",
          distance:zipInfo?`${zipInfo.miles} miles from Brookville`:"Not checked",
          notes:form.notes||"None",
        }),
      });
    }catch(_){}
    setSummary({vehicleType:form.vehicleType,service:form.serviceType,time:svcData?.time,price:currentPrice,contactPreference:form.contactPreference,days:selectedDays,timePref});
    setSubmitted(true);setSubmitting(false);
    setTimeout(()=>confirmRef.current?.scrollIntoView({behavior:"smooth",block:"start"}),100);
  };

  return(
    <div style={{fontFamily:"'Outfit',sans-serif",background:"#fff",color:TEXT,minHeight:"100vh"}}>
      <style>{GLOBAL_STYLES}</style>

      {/* Toast */}
      {toast&&(
        <div style={{position:"fixed",top:76,left:"50%",transform:"translateX(-50%)",zIndex:600,background:NAVY,color:"#fff",padding:"11px 22px",borderRadius:8,fontSize:14,fontWeight:600,boxShadow:"0 4px 20px rgba(0,0,0,0.2)",animation:"toast-in 0.25s ease",whiteSpace:"nowrap"}}>
          {toast}
        </div>
      )}

      {/* Sticky mobile bar */}
      {scrolled&&!bookInView&&(
        <div className="sticky-bar" style={{position:"fixed",bottom:0,left:0,right:0,zIndex:200,background:"#fff",borderTop:"1px solid #E5E7EB",padding:"12px 20px",alignItems:"center",justifyContent:"space-between",boxShadow:"0 -4px 16px rgba(0,0,0,0.08)"}}>
          <div>
            <p style={{fontSize:13,fontWeight:700,color:NAVY}}>Kodiak Detailing</p>
            <p style={{fontSize:11,color:MUTED}}>Brookville, Ohio</p>
          </div>
          <button className="btn-p" style={{padding:"10px 22px",fontSize:14}} onClick={()=>scrollTo("book")}>Book Now</button>
        </div>
      )}

      <Navbar activePage="home"/>

      {/* ── HERO ── */}
      <section className="hero-pad" style={{minHeight:"90vh",background:"#fff",display:"flex",flexDirection:"column",justifyContent:"center",padding:"110px 48px 70px",borderBottom:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:820,margin:"0 auto",width:"100%"}}>
          <div style={{display:"inline-flex",alignItems:"center",gap:7,background:LIGHT,border:`1px solid ${BLUE}22`,borderRadius:20,padding:"5px 14px",marginBottom:20}}>
            <span style={{width:7,height:7,borderRadius:"50%",background:BLUE,display:"inline-block"}}/>
            <span style={{fontSize:12,fontWeight:600,color:BLUE}}>Now Serving Brookville, Ohio and the Surrounding Dayton Area</span>
          </div>
          <h1 style={{fontSize:"clamp(40px,6vw,68px)",fontWeight:800,lineHeight:1.06,color:NAVY,marginBottom:16,letterSpacing:"-0.02em"}}>
            Your Car.<br/>Clean and <span style={{color:BLUE}}>Simple.</span>
          </h1>
          <p style={{fontSize:16,color:MUTED,lineHeight:1.75,maxWidth:460,marginBottom:32}}>
            Professional mobile and drop-off auto detailing serving Brookville, Dayton, Englewood, Vandalia, and surrounding Ohio communities. Interior, exterior, or both.
          </p>
          <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:44}}>
            <button className="btn-p" style={{fontSize:15,padding:"13px 32px"}} onClick={()=>scrollTo("book")}>Book Now</button>
            <button className="btn-o" onClick={()=>scrollTo("services")}>See Services</button>
          </div>
          <div style={{display:"flex",gap:44,flexWrap:"wrap"}}>
            {[["200+","Cars Serviced"],["100%","Satisfaction"],["$100","Starting Price"]].map(([n,l])=>(
              <div key={l}>
                <div style={{fontSize:28,fontWeight:800,color:NAVY,letterSpacing:"-0.02em"}}>{n}</div>
                <div style={{fontSize:12,color:MUTED,fontWeight:500}}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section style={{padding:"52px 48px",background:NAVY}}>
        <div style={{maxWidth:800,margin:"0 auto"}}>
          <div className="three-col" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:24,textAlign:"center"}}>
            {[["📋","Fill out the form","2 minutes"],["✅","Get a reply","We confirm your slot"],["🚗","Car gets detailed","Done right, every time"]].map(([icon,title,sub])=>(
              <div key={title}>
                <div style={{fontSize:28,marginBottom:10}}>{icon}</div>
                <p style={{fontSize:14,fontWeight:700,color:"#fff",marginBottom:4}}>{title}</p>
                <p style={{fontSize:12,color:"rgba(255,255,255,0.45)"}}>{sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section id="services" style={{padding:"72px 48px",background:"#fff"}}>
        <div style={{maxWidth:680,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>What We Do</p>
          <h2 style={{fontSize:"clamp(22px,3vw,36px)",fontWeight:800,color:NAVY,marginBottom:8,letterSpacing:"-0.02em"}}>Two Services. No Confusion.</h2>
          <p style={{fontSize:14,color:MUTED,marginBottom:24}}>Tap a service to learn more.</p>
          <ServicesAccordion onBook={bookService}/>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section id="pricing" style={{padding:"64px 48px",background:"#F9FAFB",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:600,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>Pricing</p>
          <h2 style={{fontSize:"clamp(22px,3vw,36px)",fontWeight:800,color:NAVY,marginBottom:8,letterSpacing:"-0.02em"}}>What It Costs</h2>
          <p style={{fontSize:14,color:MUTED,marginBottom:24}}>Tap any service to see pricing by vehicle size.</p>
          <PricingAccordion/>
          <div style={{marginTop:22,textAlign:"center"}}>
            <button className="btn-p" onClick={()=>scrollTo("book")}>Book Now</button>
          </div>
        </div>
      </section>

      {/* ── BEFORE / AFTER ── */}
      <section style={{padding:"64px 48px",background:"#fff",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:820,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>Results</p>
          <h2 style={{fontSize:"clamp(20px,3vw,34px)",fontWeight:800,color:NAVY,marginBottom:8,letterSpacing:"-0.02em"}}>See the difference.</h2>
          <p style={{fontSize:13,color:MUTED,marginBottom:20}}>Drag the handle to compare.</p>
          <BeforeAfterSlider before="/after.jpg" after="/before.jpg"/>
        </div>
      </section>

      {/* ── REVIEWS ── */}
      <section style={{padding:"64px 48px",background:"#F9FAFB",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:700,margin:"0 auto",textAlign:"center"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>What People Say</p>
          <h2 style={{fontSize:"clamp(20px,3vw,34px)",fontWeight:800,color:NAVY,marginBottom:36,letterSpacing:"-0.02em"}}>Customer Reviews</h2>
          <ReviewsCarousel/>
        </div>
      </section>

      {/* ── BOOKING FORM ── */}
      <section id="book" ref={bookRef} style={{padding:"72px 48px",background:"#fff",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:660,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>Get Started</p>
          <h2 style={{fontSize:"clamp(22px,3vw,36px)",fontWeight:800,color:NAVY,marginBottom:8,letterSpacing:"-0.02em"}}>Book Your Detail</h2>
          <p style={{color:MUTED,fontSize:14,marginBottom:24}}>Fill this out and you will hear back to confirm your appointment.</p>

          {submitted&&summary?(
            <div ref={confirmRef}>
              <div style={{background:"#fff",border:`2px solid ${BLUE}`,borderRadius:12,padding:"40px 28px",textAlign:"center",marginBottom:13}}>
                <div style={{width:52,height:52,borderRadius:"50%",background:LIGHT,border:`2px solid ${BLUE}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,color:BLUE,fontWeight:800,margin:"0 auto 16px"}}>✓</div>
                <h3 style={{fontSize:22,fontWeight:800,color:NAVY,marginBottom:7}}>Request Sent!</h3>
                <p style={{color:MUTED,fontSize:14,marginBottom:22}}>Your request has been received. A reply will come via <strong style={{color:NAVY}}>{summary.contactPreference}</strong> to lock in your appointment.</p>
                <div style={{background:"#F9FAFB",border:"1.5px solid #E5E7EB",borderRadius:10,padding:"16px 20px",textAlign:"left",marginBottom:14}}>
                  <p style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:11}}>Your Booking Summary</p>
                  {[
                    ["Vehicle",summary.vehicleType],
                    ["Service",summary.service],
                    ["Estimated Time",summary.time],
                    ["Contact Via",summary.contactPreference.charAt(0).toUpperCase()+summary.contactPreference.slice(1)],
                    ...(summary.days?.length>0?[["Preferred Days",summary.days.join(", ")]]:[] ),
                    ...(summary.timePref?[["Time of Day",summary.timePref]]:[]),
                  ].map(([label,value])=>(
                    <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #F3F4F6"}}>
                      <span style={{fontSize:13,color:MUTED,fontWeight:500}}>{label}</span>
                      <span style={{fontSize:13,fontWeight:700,color:NAVY}}>{value}</span>
                    </div>
                  ))}
                  {summary.price&&(
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0 0",marginTop:2}}>
                      <span style={{fontSize:13,color:MUTED,fontWeight:500}}>Estimated Price</span>
                      <span style={{fontSize:15,fontWeight:800,color:NAVY}}>${summary.price}</span>
                    </div>
                  )}
                </div>
                <p style={{fontSize:12,color:MUTED,lineHeight:1.7}}>This is an estimate. Final pricing confirmed before the appointment starts.</p>
              </div>
              <div style={{background:LIGHT,border:`1.5px solid ${BLUE}22`,borderRadius:10,padding:"12px 16px",textAlign:"center"}}>
                <p style={{fontSize:13,color:NAVY,fontWeight:600}}>Scroll down to read how to prepare and get answers to common questions.</p>
              </div>
            </div>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:13}}>
              <StepBar step={formStep}/>

              {/* Step 1 */}
              <div className="fcard">
                <h3>1. Your Info</h3>
                <div className="two-col" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:11}}>
                  <div style={{gridColumn:"1/-1"}}>
                    <input placeholder="Full Name *" value={form.name} onChange={e=>set("name",e.target.value)}/>
                    {errors.name&&<p className="err">{errors.name}</p>}
                  </div>
                  <div>
                    <input type="tel" placeholder="Phone Number *" value={form.phone} onChange={e=>set("phone",e.target.value)}/>
                    {errors.phone&&<p className="err">{errors.phone}</p>}
                  </div>
                  <div>
                    <input type="email" placeholder={form.contactPreference==="email"?"Email *":"Email (optional)"} value={form.email} onChange={e=>set("email",e.target.value)}/>
                    {errors.email&&<p className="err">{errors.email}</p>}
                  </div>
                </div>
                <div style={{marginTop:14}}>
                  <p style={{fontSize:13,fontWeight:600,color:NAVY,marginBottom:9}}>Preferred way to reply back *</p>
                  <div className="three-col" style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                    {[["text","📱 Text"],["call","📞 Call"],["email","✉️ Email"]].map(([val,label])=>(
                      <div key={val} className={`rrow${form.contactPreference===val?" on":""}`} onClick={()=>set("contactPreference",val)} style={{alignItems:"center"}}>
                        <RadioDot checked={form.contactPreference===val}/>
                        <span style={{fontSize:13,fontWeight:600,color:form.contactPreference===val?NAVY:MUTED}}>{label}</span>
                      </div>
                    ))}
                  </div>
                  {errors.contactPreference&&<p className="err">{errors.contactPreference}</p>}
                </div>
              </div>

              {/* Step 2 */}
              <div className="fcard">
                <h3>2. Your Vehicle</h3>
                <p style={{fontSize:12,color:MUTED,marginBottom:12}}>Select the type that best matches your car size.</p>
                <div className="four-col" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
                  {VEHICLE_TYPES.map(v=>(
                    <div key={v.id} className={`vcard${form.vehicleType===v.label?" on":""}`} onClick={()=>set("vehicleType",v.label)}>
                      <img src={v.img} alt={v.label} onError={e=>{e.target.style.display="none";}}/>
                      <div className="vcard-info">
                        <div className="vcard-label">{v.label}</div>
                        <div className="vcard-ex">{v.examples}</div>
                      </div>
                    </div>
                  ))}
                </div>
                {errors.vehicleType&&<p className="err" style={{marginTop:7}}>{errors.vehicleType}</p>}
                <p style={{fontSize:11,color:"#9CA3AF",marginTop:8}}>Larger vehicles may require more time. Pricing confirmed before the appointment.</p>
                <div className="two-col" style={{marginTop:12,display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <div style={{gridColumn:"1/-1"}}>
                    <input placeholder="Make and Model (optional, e.g. Honda Civic, Chevy Tahoe)" value={form.makeModel} onChange={e=>set("makeModel",e.target.value)}/>
                  </div>
                  <div>
                    <input placeholder="Color (e.g. White)" value={form.color} onChange={e=>set("color",e.target.value)}/>
                  </div>
                  <div style={{gridColumn:"1/-1"}}>
                    <p style={{fontSize:12,color:MUTED,marginBottom:8}}>How would you describe your car's current condition?</p>
                    <div style={{display:"flex",gap:10,marginBottom:9,flexWrap:"wrap"}}>
                      {CONDITIONS.map(c=>(
                        <div key={c.id} style={{display:"flex",alignItems:"center",gap:5}}>
                          <div style={{width:9,height:9,borderRadius:"50%",background:c.dot}}/>
                          <span style={{fontSize:11,color:c.color,fontWeight:600}}>{c.label}</span>
                        </div>
                      ))}
                    </div>
                    <select value={form.condition} onChange={e=>set("condition",e.target.value)}>
                      <option value="">Select condition *</option>
                      {CONDITIONS.map(c=><option key={c.id} value={c.label}>{c.icon} {c.label}</option>)}
                    </select>
                    {errors.condition&&<p className="err">{errors.condition}</p>}
                    {selectedCondition&&(
                      <div style={{marginTop:8,background:LIGHT,borderRadius:8,padding:"9px 13px",borderLeft:`3px solid ${selectedCondition.dot}`}}>
                        <p style={{fontSize:12,color:NAVY,fontWeight:600,marginBottom:2}}>{selectedCondition.icon} {selectedCondition.label}</p>
                        <p style={{fontSize:12,color:MUTED,lineHeight:1.6}}>{selectedCondition.desc}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="fcard">
                <h3>3. Service *</h3>
                {errors.serviceType&&<p className="err" style={{marginBottom:9}}>{errors.serviceType}</p>}
                <div style={{display:"flex",flexDirection:"column",gap:9}}>
                  {SERVICES.map(s=>{
                    const tier=getVehicleTier(form.vehicleType);
                    const key=s.id==="combo"?"combo":s.id==="interior"?"interior":"exterior";
                    const price=tier?PRICING[key][tier]:null;
                    const savings=s.id==="combo"&&tier?COMBO_SAVINGS[tier]:null;
                    return(
                      <div key={s.id} className={`rrow${form.serviceType===s.title?" on":""}`} onClick={()=>set("serviceType",s.title)}>
                        <div style={{marginTop:2,flexShrink:0}}><RadioDot checked={form.serviceType===s.title}/></div>
                        <div style={{display:"flex",flexDirection:"column",gap:3,flex:1,minWidth:0}}>
                          <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",gap:6}}>
                            <span style={{fontWeight:700,color:form.serviceType===s.title?NAVY:TEXT,fontSize:14}}>{s.title}</span>
                            {s.badge&&<span style={{background:BLUE,color:"#fff",fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:4}}>{s.badge}</span>}
                          </div>
                          <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",gap:6,marginTop:2}}>
                            <span style={{fontSize:12,fontWeight:700,color:BLUE}}>{price?`$${price}`:s.priceFrom}</span>
                            <span style={{fontSize:11,color:"#9CA3AF"}}>· {s.time}</span>
                            {savings&&<span style={{fontSize:11,fontWeight:600,color:GREEN}}>· Save ${savings}</span>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {currentPrice&&(
                  <div style={{marginTop:12,background:LIGHT,border:`1.5px solid ${BLUE}33`,borderRadius:8,padding:"12px 15px"}}>
                    <p style={{fontSize:12,color:NAVY,fontWeight:600}}>Estimated price for your {form.vehicleType}:</p>
                    <p style={{fontSize:22,fontWeight:800,color:BLUE,marginTop:2}}>${currentPrice}</p>
                    {comboSavings&&<p style={{fontSize:12,fontWeight:600,color:GREEN,marginTop:3}}>You save ${comboSavings} vs booking separately</p>}
                    <p style={{fontSize:11,color:MUTED,marginTop:3}}>Estimate only, confirmed at booking.</p>
                  </div>
                )}
              </div>

              {/* Step 4 */}
              <div className="fcard">
                <h3>4. Appointment Type *</h3>
                <p style={{fontSize:12,color:MUTED,marginBottom:12}}>Both options available, your choice.</p>
                {isWinter&&(
                  <div style={{background:"#FEF9EE",border:"1px solid #F59E0B",borderRadius:8,padding:"10px 14px",marginBottom:12,fontSize:12,color:"#92400E",fontWeight:500}}>
                    Mobile detailing is paused November through March. Drop-off in Brookville is available year-round.
                  </div>
                )}
                <div className="appt-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  <div className={`appt-card${form.appointmentType==="mobile"?" on":""}${isWinter?" dis":""}`} onClick={()=>!isWinter&&set("appointmentType","mobile")}>
                    <div style={{display:"flex",alignItems:"center",gap:9}}><RadioDot checked={form.appointmentType==="mobile"}/><span style={{fontSize:14,fontWeight:700,color:form.appointmentType==="mobile"?NAVY:TEXT}}>📱 Mobile</span></div>
                    <p style={{fontSize:12,color:MUTED,paddingLeft:27}}>Service comes to you</p>
                    {!isWinter?<p style={{fontSize:11,color:GREEN,paddingLeft:27,fontWeight:600}}>✓ Available now through late October</p>:<p style={{fontSize:11,color:MUTED,paddingLeft:27}}>Unavailable in winter</p>}
                  </div>
                  <div className={`appt-card${form.appointmentType==="stationary"?" on":""}`} onClick={()=>set("appointmentType","stationary")}>
                    <div style={{display:"flex",alignItems:"center",gap:9}}><RadioDot checked={form.appointmentType==="stationary"}/><span style={{fontSize:14,fontWeight:700,color:form.appointmentType==="stationary"?NAVY:TEXT}}>🏠 Drop-Off</span></div>
                    <p style={{fontSize:12,color:MUTED,paddingLeft:27}}>Bring your car to Brookville</p>
                    <p style={{fontSize:11,color:GREEN,paddingLeft:27,fontWeight:600}}>✓ Available year-round</p>
                  </div>
                </div>
                {errors.appointmentType&&<p className="err" style={{marginTop:7}}>{errors.appointmentType}</p>}
                {form.appointmentType==="stationary"&&(
                  <div style={{marginTop:12}}>
                    <div onClick={copyAddress} style={{display:"flex",alignItems:"center",justifyContent:"space-between",background:"#F9FAFB",border:"1.5px solid #E5E7EB",borderRadius:8,padding:"9px 13px",cursor:"pointer"}}>
                      <span style={{fontSize:13,color:TEXT,fontWeight:600}}>📍 Brookville, Ohio 45309</span>
                      <span style={{fontSize:11,color:copyMsg?BLUE:MUTED,fontWeight:600,flexShrink:0,marginLeft:8}}>{copyMsg||"tap to copy"}</span>
                    </div>
                    <div style={{display:"flex",gap:12,marginTop:7}}>
                      <a href={GMAPS_URL} target="_blank" rel="noopener noreferrer" style={{fontSize:12,fontWeight:600,color:BLUE,textDecoration:"none"}}>Google Maps</a>
                      <span style={{color:"#D1D5DB"}}>|</span>
                      <a href={AMAPS_URL} target="_blank" rel="noopener noreferrer" style={{fontSize:12,fontWeight:600,color:BLUE,textDecoration:"none"}}>Apple Maps</a>
                    </div>
                  </div>
                )}
                {form.appointmentType==="mobile"&&(
                  <div style={{marginTop:12,display:"flex",flexDirection:"column",gap:10}}>
                    <div>
                      <input placeholder="Your Zip Code *" value={form.zip} maxLength={5} onChange={e=>handleZipChange(e.target.value)}/>
                      {errors.zip&&<p className="err">{errors.zip}</p>}
                      {zipLoading&&<p style={{fontSize:12,color:MUTED,marginTop:4}}>Checking your location...</p>}
                      {zipInfo&&!zipLoading&&<ZipResult zipInfo={zipInfo}/>}
                    </div>
                    <input placeholder="Your address (optional, helps with planning)" value={form.address} onChange={e=>set("address",e.target.value)}/>
                  </div>
                )}
              </div>

              {/* Day + time picker */}
              <DayTimePicker selectedDays={selectedDays} toggleDay={toggleDay} timePref={timePref} setTimePref={setTimePref}/>

              {/* Notes */}
              <div className="fcard">
                <h3>Extra Notes / Anything Else</h3>
                <textarea rows={3} placeholder="Specific concerns, questions, anything at all." value={form.notes} onChange={e=>set("notes",e.target.value)} style={{resize:"vertical"}}/>
              </div>

              {/* Submit */}
              <div style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:10,padding:"20px 22px"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:14,marginBottom:12}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <PulsingDot/>
                    <p style={{fontSize:14,fontWeight:600,color:TEXT}}>Typically responds within 2 to 4 hours</p>
                  </div>
                  <button className="btn-p" style={{padding:"13px 28px",fontSize:14}} onClick={handleSubmit} disabled={submitting}>
                    {submitting?"Sending...":"Submit Request"}
                  </button>
                </div>
                <div style={{borderTop:"1px solid #F3F4F6",paddingTop:11,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                  <p style={{fontSize:11,color:"#9CA3AF"}}>All information is kept private and secure.</p>
                  <a href={`sms:+1${QUICK_Q_PHONE}?&body=Hi, I have a quick question about booking a detail.`} style={{fontSize:12,color:BLUE,fontWeight:600,textDecoration:"none",whiteSpace:"nowrap"}}>Have a question? Text us →</a>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ── HOW TO PREPARE ── */}
      <section style={{padding:"56px 48px",background:"#F9FAFB",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:720,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>Before Your Appointment</p>
          <h2 style={{fontSize:"clamp(20px,3vw,32px)",fontWeight:800,color:NAVY,marginBottom:24,letterSpacing:"-0.02em"}}>How to Prepare</h2>
          <div className="two-col" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            {[["🅿️","Park in shade if possible","Shade helps the chemicals work better for mobile visits."],["👜","Remove personal belongings","Phones, wallets, sunglasses, anything important out before the appointment."],["🗑️","Everyday trash can stay","Cups, receipts, general mess is fine. That is what the detail is for."],["📦","Clear large bulky items","Anything taking significant space should be removed so every area can be reached."]].map(([icon,title,desc])=>(
              <div key={title} style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:10,padding:"16px 18px"}}>
                <div style={{fontSize:18,marginBottom:7}}>{icon}</div>
                <h4 style={{fontSize:13,fontWeight:700,color:NAVY,marginBottom:4}}>{title}</h4>
                <p style={{fontSize:12,color:MUTED,lineHeight:1.65}}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* SERVICE AREAS - SEO */}
      <section style={{padding:"56px 48px",background:"#F9FAFB",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:860,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>Where We Serve</p>
          <h2 style={{fontSize:"clamp(20px,3vw,32px)",fontWeight:800,color:NAVY,marginBottom:8,letterSpacing:"-0.02em"}}>Auto Detailing Near You</h2>
          <p style={{fontSize:14,color:MUTED,marginBottom:28,maxWidth:540}}>
            Serving Brookville, Ohio and communities throughout the greater Dayton area. Mobile service comes to you. Drop-off is available in Brookville year-round.
          </p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10}}>
            {[
              "Brookville","Dayton","Englewood","Vandalia",
              "Trotwood","Huber Heights","Fairborn","Germantown",
              "Miamisburg","Centerville","Moraine","West Carrollton",
              "Clayton","New Lebanon","Springboro","Oakwood",
            ].map(city=>(
              <div key={city} style={{background:"#fff",border:"1.5px solid #E5E7EB",borderRadius:8,padding:"10px 14px",display:"flex",alignItems:"center",gap:8}}>
                <div style={{width:7,height:7,borderRadius:"50%",background:BLUE,flexShrink:0}}/>
                <span style={{fontSize:13,fontWeight:600,color:NAVY}}>{city}, OH</span>
              </div>
            ))}
          </div>
          <p style={{fontSize:12,color:"#9CA3AF",marginTop:16}}>
            Not seeing your city? If you are within about 30 minutes of Brookville, Ohio, mobile service is likely available. Enter your zip code in the booking form to check your distance.
          </p>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section id="faq" style={{padding:"56px 48px",background:"#fff",borderTop:"1px solid #E5E7EB"}}>
        <div style={{maxWidth:640,margin:"0 auto"}}>
          <p style={{fontSize:12,fontWeight:600,color:BLUE,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8}}>Common Questions</p>
          <h2 style={{fontSize:"clamp(20px,3vw,32px)",fontWeight:800,color:NAVY,marginBottom:28,letterSpacing:"-0.02em"}}>FAQ</h2>
          {FAQS.map(f=><FAQItem key={f.q} q={f.q} a={f.a}/>)}
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{background:NAVY,padding:"40px",textAlign:"center"}}>
        <img src="/logo.png" alt="Kodiak Detailing" style={{width:46,height:46,borderRadius:"50%",objectFit:"contain",margin:"0 auto 12px",display:"block"}}/>
        <p style={{fontSize:16,fontWeight:800,color:"#fff",marginBottom:5}}>Kodiak <span style={{color:"rgba(255,255,255,0.38)"}}>Detailing</span></p>
        <p style={{fontSize:12,color:"rgba(255,255,255,0.35)",marginBottom:2}}>Serving Brookville, Ohio and the Greater Dayton Area</p>
        <p style={{fontSize:12,color:"rgba(255,255,255,0.3)",marginBottom:16}}>kodiakdetailpro@gmail.com</p>
        <div style={{display:"flex",justifyContent:"center",gap:18,marginBottom:14}}>
          <a href="/about" style={{fontSize:12,color:"rgba(255,255,255,0.4)",textDecoration:"none"}}>About</a>
          <span style={{color:"rgba(255,255,255,0.2)"}}>·</span>
          <a href="/#services" style={{fontSize:12,color:"rgba(255,255,255,0.4)",textDecoration:"none"}}>Services</a>
          <span style={{color:"rgba(255,255,255,0.2)"}}>·</span>
          <a href="/#book" style={{fontSize:12,color:"rgba(255,255,255,0.4)",textDecoration:"none"}}>Book Now</a>
        </div>
        <p style={{fontSize:11,color:"rgba(255,255,255,0.18)"}}>2025 Kodiak Detailing. All rights reserved.</p>
      </footer>
    </div>
  );
}
